// extracted by mini-css-extract-plugin
export default {"projects":"projects_projects__zNzTM","container":"projects_container__3QrLy","isVisible":"projects_isVisible__LXwvz"};